import ReactDOM from 'react-dom';

import AnnotationService from '../../services/Annotation';
import { ANNOTATION_TYPES } from '../../constants';


export const annotationCreated = async (app, uuid, annotation, type) => {
  const { errorType, ...restAnnotation } = annotation;
  const payload = { error_type: errorType, ...restAnnotation };

  let data = null;
  switch (type) {
    case ANNOTATION_TYPES.issue:
      data = await AnnotationService.addAnnotationIssue(uuid, payload);
      break;
    case ANNOTATION_TYPES.suggestion:
      data = await AnnotationService.addAnnotationSuggestion(uuid, payload);
      break;
    default:
      throw new Error(`Annotation type ${type} not supported`);
  }

  if (data !== null) {
    app.runHook('annotationCreated', [{ ...payload, ...data }]);
  }
}

export const annotationUpdated = async (app, uuid, annotation, type) => {
  const { errorType, ...restAnnotation } = annotation;
  const payload = { error_type: errorType, ...restAnnotation }

  let data = null;
  switch (type) {
    case ANNOTATION_TYPES.issue:
      data = await AnnotationService.updateAnnotationIssue(uuid, payload);
      break;
    case ANNOTATION_TYPES.suggestion:
      data = await AnnotationService.updateAnnotationSuggestion(uuid, payload);
      break;
    default:
      throw new Error(`Annotation type ${type} not supported`);
  }

  if (data !== null) {
    app.runHook('annotationUpdated', [{ ...payload, ...data }]);
  }
}

export const annotationDeleted = async (app, uuid, annotation, type) => {
  const { id } = annotation;
  switch (type) {
    case ANNOTATION_TYPES.issue:
      await AnnotationService.deleteAnnotationIssue(uuid, id);
      break;
    case ANNOTATION_TYPES.suggestion:
      await AnnotationService.deleteAnnotationSuggestion(uuid, id);
      break;
    default:
      throw new Error(`Annotation type ${type} not supported`);
  }

  app.runHook('annotationDeleted', [annotation]);
}

export const closeAnnotator = (app, container) => {
  ReactDOM.unmountComponentAtNode(container);
  app.runHook('annotationClosed', []);
}
